import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const CityGridContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem 1rem;
	width: 100%;
`;

export const DeliverySlotContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const CityWrapper = styled.div`
	display: flex;
	align-items: end;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: start;
		padding: 2rem 0rem;
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	gap: 1rem;
	padding: 1rem;
	margin-bottom: 0.3rem;
`;

export const AddCityButtonWrapper = styled.div`
	margin-top: 1.5rem;
`;

export const MapContainer = styled.div`
	width: 100%;
	height: calc(var(--vh, 1vh) * 60);
`;
